import React from "react";
import useMetaTags from "../../hooks/useMetaTags";
import Services_we_offer from '../../component/Services_Component/Services_we_offer';
import {
  AssistanceSection,
  BenefitSection,
  BoostSection,
  CustomSection,
  FAQ,
  LargeData,
  ServicesSection,
  roleWriting,
} from "../../Data/All_Services_Data/localSeoData";
import Custom_section from "../../component/Services_Component/Custom_services_section";
import Benefits_section from "../../component/Services_Component/Benefits_section";
import Boost_section from "../../component/Services_Component/Boost_section";
import Assistance_section from "../../component/Services_Component/Assistance_section";
import FAQ_section from "../../component/Services_Component/FAQ_section";
import Role_writing from "../../component/Services_Component/Role_writing";
import Handle_Largedata_section from "../../component/Services_Component/Handle_Largedata_section";

const LocalSeoService = () => {
  useMetaTags({
    title: "Local SEO Services | Professional Local SEO Experts Warrgyizmorsch",
    description:
      "Local SEO services by Warrgyizmorsch help your business rank higher in local searches. Drive foot traffic, leads, and visibility with expert local SEO strategies.",
    keywords:
      "local seo, local seo agency, local seo service, local seo optimization, local seo service, local seo experts, local seo solutions, local search engine, Local SEO Company",
  });
  return (
    <>
      <section
        className=""
        style={{
          backgroundImage: `url('assets/img/service/serviceD.jpg')`,
          backgroundPosition: "center",
          backgroundSize: "cover",
        }}
        id="service-sec"
      >
        <div className="round-container pt-5">
          <div className="container">
            <div className="title-area text-center">
              <span className="sub-title text-white">OUR SERVICES</span>
              <h2 className="sec-title text-white">
                Enhance Your Local Presence with Our Professional Local SEO
                Services
              </h2>
            </div>
          </div>
        </div>
      </section>
      <section className="space-extra-bottom">
        <div className="page-single">
          <div className="page-content">
            <style>{`
                    .header-section{
            display: flex;
            align-items: center;
            gap: 20px;
            margin-bottom: 30px;
        }
        .header-section img{
            height: 400px;
        }
        .header-section p{
            text-align: left;
        }

        .extra-box{
          display: flex;
          height: 70px;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          padding: 25px;
        }

        @media only screen and (max-width: 990px) {
        .header-section{
            flex-direction: column;
        }
        .header-section img{
            height: 200px;
        }
            .header-section p{
            text-align: center;
        }
        }
                `}</style>
            {/* Intro part  */}
            <div
              className="header-section container"
              style={{ marginTop: "20px" }}
            >
              <img
                src="assets/img/icon/localSeoimage.png"
                loading="lazy"
                alt="heading_image"
              />
              <div>
                <p>
                  In terms of content strategy and community engagement we are
                  right there with local businesses to put together campaigns
                  which see real results. We are not just about clicks for you,
                  we help you build local SEO out of those connections which in
                  turn will turn into dedicated customers. Let’s improve your
                  local online presence together.
                </p>
              </div>
            </div>
            {/* Customizable, End-to-End Services Built Around Your Requirements  */}
            <Services_we_offer data={ServicesSection} />

            {/* How to Choose the Best Local SEO Company? */}
            <Handle_Largedata_section LargeData={LargeData} />

            {/* Why Choose Warrgyizmorsch as Your Local SEO Agency?  */}
            <Custom_section data={CustomSection} />

            {/* Why Choose Warrgyizmorsch?  */}
            <Benefits_section data={BenefitSection} />

            {/* Unlocking Growth: The Power of Local SEO for Your Business  */}
            <Role_writing data={roleWriting} />

            {/* Expand Your Local Reach with Warrgyizmorsch Local SEO Services  */}
            <Boost_section data={BoostSection} />

            <div className="extra-box"></div>

            {/* FAQ section  */}
            <FAQ_section data={FAQ} />
          </div>
        </div>
      </section>
      <div className="scroll-top">
        <svg
          className="progress-circle svg-content"
          width="100%"
          height="100%"
          viewBox="-1 -1 102 102"
        >
          <path
            d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98"
            style={{
              transition: "stroke-dashoffset 10ms linear 0s",
              strokeDasharray: "307.919, 307.919",
              strokeDashoffset: "307.919",
            }}
          ></path>
        </svg>
      </div>
    </>
  );
};

export default LocalSeoService;
